// // pages/admin/StoryCreate.jsx
// import { useEditor } from "@tiptap/react";
// import StarterKit from "@tiptap/starter-kit";
// import { RichTextEditor } from "@mantine/tiptap";
// import { useParams, useNavigate } from "react-router-dom";
// import { createStory } from "../../utils/api";
// import Underline from "@tiptap/extension-underline";
// import Highlight from "@tiptap/extension-highlight";
// import Link from "@tiptap/extension-link";
// import TextAlign from "@tiptap/extension-text-align";
// import Superscript from "@tiptap/extension-superscript";
// import Subscript from "@tiptap/extension-subscript";
// export default function StoryCreate() {
//   const { topicId } = useParams();
//   const navigate = useNavigate();

//   const editor = useEditor({
//   extensions: [
//     StarterKit,
//     Underline,
//     Highlight,
//     Link,
//     Superscript,
//     Subscript,
//     TextAlign.configure({
//       types: ["heading", "paragraph"],
//     }),
//   ],
//   content: "",
// });

//   const handleSave = async () => {
//     const html = editor.getHTML();
//     if (html === "<p></p>") return alert("Content required");

//     await createStory({
//       topicId,
//       content: html,
//       language: "he",
//     });

//     navigate(`/stories/${topicId}`);
//   };

//   return (
//     <div className="users-page">
//       <h1 className="page-title">Add Story</h1>

//       <div className="table-wrapper">
//         <div style={{ padding: 16 }}>
//         <RichTextEditor editor={editor}>
//             <RichTextEditor.Toolbar sticky>
//               <RichTextEditor.ControlsGroup>
//                 <RichTextEditor.Bold />
//                 <RichTextEditor.Italic />
//                 <RichTextEditor.Underline />
//                 <RichTextEditor.Strikethrough />
//                 <RichTextEditor.ClearFormatting />
//               </RichTextEditor.ControlsGroup>

//               <RichTextEditor.ControlsGroup>
//                 <RichTextEditor.H1 />
//                 <RichTextEditor.H2 />
//                 <RichTextEditor.H3 />
//                 <RichTextEditor.H4 />
//               </RichTextEditor.ControlsGroup>

//               <RichTextEditor.ControlsGroup>
//                 <RichTextEditor.Blockquote />
//                 <RichTextEditor.BulletList />
//                 <RichTextEditor.OrderedList />
//               </RichTextEditor.ControlsGroup>

//               <RichTextEditor.ControlsGroup>
//                 <RichTextEditor.AlignLeft />
//                 <RichTextEditor.AlignCenter />
//                 <RichTextEditor.AlignRight />
//               </RichTextEditor.ControlsGroup>

//               <RichTextEditor.ControlsGroup>
//                 {/* <RichTextEditor.Undo />
//                 <RichTextEditor.Redo /> */}
//               </RichTextEditor.ControlsGroup>
//             </RichTextEditor.Toolbar>

//           <RichTextEditor.Content style={{
//     minHeight: 300,
//     maxHeight: 450,
//     overflowY: "auto",
//     padding: "12px",
//   }}  />
//           </RichTextEditor>

//           <div style={{ marginTop: 12, textAlign: "right" }}>
//             <button className="action-btn activate" onClick={handleSave}>
//               Save Story
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// pages/admin/StoryCreate.jsx
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { RichTextEditor } from "@mantine/tiptap";
import { useParams, useNavigate } from "react-router-dom";
import { createStory } from "../../utils/api";

import Underline from "@tiptap/extension-underline";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Superscript from "@tiptap/extension-superscript";
import Subscript from "@tiptap/extension-subscript";

const extensions = [
  StarterKit,
  Underline,
  Highlight,
  Link,
  Superscript,
  Subscript,
  TextAlign.configure({
    types: ["heading", "paragraph"],
  }),
];

const editorStyle = {
  minHeight: 250,
  maxHeight: 400,
  overflowY: "auto",
  padding: "12px",
};

export default function StoryCreate() {
  const { topicId } = useParams();
  const navigate = useNavigate();

  const editorEN = useEditor({ extensions, content: "" });
  const editorHE = useEditor({ extensions, content: "" });
  const editorYI = useEditor({ extensions, content: "" });

  const handleSave = async () => {
    const en = editorEN?.getHTML();
    const he = editorHE?.getHTML();
    const yi = editorYI?.getHTML();

    if (
      (!en || en === "<p></p>") &&
      (!he || he === "<p></p>") &&
      (!yi || yi === "<p></p>")
    ) {
      return alert("At least one language is required");
    }

    // 🔹 Option A: single row with 3 columns
    await createStory({
      topicId,
      content: en,
      content_he: he,
      content_yi: yi,
    });

    navigate(`/stories/${topicId}`);
  };

  const EditorBlock = ({ title, editor, dir }) => (
    <div style={{ marginBottom: 24 }}>
      <h3
      className="text-sm font-semibold mb-2"
      dir={dir}
      style={{ textAlign: dir === "rtl" ? "right" : "left" }}
    >
      {title}
    </h3>
      <RichTextEditor editor={editor}>
        <RichTextEditor.Toolbar sticky>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Bold />
            <RichTextEditor.Italic />
            <RichTextEditor.Underline />
            <RichTextEditor.Strikethrough />
            <RichTextEditor.ClearFormatting />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.H1 />
            <RichTextEditor.H2 />
            <RichTextEditor.H3 />
            <RichTextEditor.H4 />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.BulletList />
            <RichTextEditor.OrderedList />
            <RichTextEditor.Blockquote />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.AlignLeft />
            <RichTextEditor.AlignCenter />
            <RichTextEditor.AlignRight />
          </RichTextEditor.ControlsGroup>
        </RichTextEditor.Toolbar>

        <RichTextEditor.Content style={editorStyle} dir={dir} />
      </RichTextEditor>
    </div>
  );

  return (
    <div className="users-page">
      <h1 className="page-title">Add Story</h1>

      <div className="table-wrapper">
        <div style={{ padding: 16 }}>
          <EditorBlock title="English" editor={editorEN} dir="ltr" />
          <EditorBlock title="עברית" editor={editorHE} dir="rtl" />
          <EditorBlock title="יידיש" editor={editorYI} dir="rtl" />
          

          <div style={{ textAlign: "right", marginTop: 12 }}>
            <button className="action-btn activate" onClick={handleSave}>
              Save Story
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
